const objectHasValues = obj => Object.values(obj).some(o => o);
export default objectHasValues;